import { TextLink, TextLinkVariant } from '@mgmresorts/mgm-ui';
import { navigate } from 'hookrouter';
import React from 'react';
import styled from 'styled-components';

export const Link = styled(TextLink)``;

export const NavigationLink = ({
  path,
  children,
  onClick,
  onMouseDown,
  variant = 'small',
  ...props
}: {
  className?: string;
  onClick?: () => void;
  onMouseDown?: () => void;
  children: React.ReactNode | React.ReactNodeArray;
  path: string;
  variant?: TextLinkVariant;
}) => {
  return (
    <TextLink
      button
      variant={variant}
      href={path}
      data-testid='navigation-link'
      {...props}
      onClick={e => {
        e.preventDefault();
        onClick && onClick();
        navigate(path);
      }}
      onMouseDown={e => {
        e.preventDefault();
        onMouseDown && onMouseDown();
        navigate(path);
      }}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          onMouseDown && onMouseDown();
          navigate(path);
        }
      }}
    >
      {children}
    </TextLink>
  );
};
